import { useState } from "react";
import { useRecoilState } from "recoil";
import { isShowGuideDownloadModal } from "src/atoms";
import { setCookie } from "src/utils/cookie";
const useGuideDownloadModal = () => {
  const [showGuideDownloadModal, setShowGuideDownloadModal] = useRecoilState(
    isShowGuideDownloadModal
  );
  const [doNotOpenGuide, setDoNotOpenGuide] = useState<boolean>(false);
  const [detailIndex, setDetailIndex] = useState<number>(0);

  // const openEco = ({ domainName }: { domainName: string }) => {
  //   // serviceList 어디서 세팅해야하는지 찾아보기
  //   // window.open("https://" + serviceList[detailIndex].domainName);
  //   window.open("https://" + domainName);
  // };
  const guideDownloadModal = () => {
    setShowGuideDownloadModal(true);
  };
  const goEcoAdmin = ({ domainName }: { domainName: string }) => {
    // serviceList 어디서 세팅해야하는지 찾아보기
    // window.open("https://" + serviceList[detailIndex].domainName + "/admin");
    if (doNotOpenGuide) {
      guideDownloadModal();
      // setShowGuideDownloadModal(true);
    } else {
      // goEcoAdmin({
      window.open("https://" + domainName + "/admin");
      //   domainName: serviceList ? serviceList[detailIndex].domainName : "",
      // });
    }
  };
  const handleChangeGuide = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDoNotOpenGuide((prev) => !prev);
  };
  const closeButtonGuide = () => {
    if (doNotOpenGuide) {
      const timestamp = new Date().getTime();
      const expire = timestamp + 1000 * 60 * 60 * 24;
      const expireDate = new Date(expire);
      setCookie({
        name: "close30dGuide",
        value: "YES",
        options: { path: "/", expires: expireDate },
      });
    }

    setShowGuideDownloadModal(false);
  };
  return {
    showGuideDownloadModal,
    setShowGuideDownloadModal,
    // serviceList,
    // setServiceList,
    doNotOpenGuide,
    setDoNotOpenGuide,
    detailIndex,
    setDetailIndex,
    // openEco,
    goEcoAdmin,
    handleChangeGuide,
    closeButtonGuide,
  };
};

export default useGuideDownloadModal;
